import CodeEditor from '.';

interface PropsShape {
    value: string;
    onChange: (code: string) => void;
}

const CSSEditor = (props: PropsShape) => {
    return <CodeEditor language="scss" value={props.value} onChange={props.onChange} />;
};

export default CSSEditor;
